var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayiMarkOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "behind-front"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 150,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 60)",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "behind-middle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 150,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 43,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 74)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 60)",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#behind-middle)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 57,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 88)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#behind-front)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 43,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 74)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 62,
    height: 62,
    rx: 13,
    transform: "rotate(45 60 60)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 55,
    r: 5,
    fill: "#fff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 55,
    r: 5,
    fill: "#fff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 67 Q60 77 71 67",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayiMarkOutline);
export default __webpack_public_path__ + "static/media/layi-mark-outline.aea8252b54696dde206d8a50bf78d2e2.svg";
export { ForwardRef as ReactComponent };